import { render, staticRenderFns } from "./Panier_Produits_Liste.vue?vue&type=template&id=83c7df9e&scoped=true&"
import script from "./Panier_Produits_Liste.vue?vue&type=script&lang=js&"
export * from "./Panier_Produits_Liste.vue?vue&type=script&lang=js&"
import style0 from "./Panier_Produits_Liste.vue?vue&type=style&index=0&id=83c7df9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83c7df9e",
  null
  
)

export default component.exports